import { Link, Outlet, useLocation } from 'react-router-dom'

const PUZZLE_LABELS: Record<string, string> = {
  sudoku:    'Sudoku',
  crossword: 'Crossword',
  rebus:     'Rebus',
  maze:      'Maze',
  math:      'Math Puzzle',
}

export default function Layout() {
  const location = useLocation()
  const segment = location.pathname.split('/')[1]
  const puzzleLabel = PUZZLE_LABELS[segment]

  return (
    <div className="min-h-screen bg-bubble-bg flex flex-col">
      <header className="bg-bubble-coral">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 text-white hover:opacity-90 transition-opacity"
            aria-label="Home"
          >
            <span className="text-2xl" aria-hidden>🧩</span>
            <span className="font-display font-black text-xl tracking-tight">PuzzleKids</span>
          </Link>

          {puzzleLabel && (
            <>
              <span className="text-white/40" aria-hidden>/</span>
              <span className="font-display font-black text-white/90">{puzzleLabel}</span>
            </>
          )}
        </div>
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-8">
        <Outlet />
      </main>

      <footer className="border-t-2 border-bubble-coral-light bg-white">
        <div className="max-w-5xl mx-auto px-4 py-3 text-center text-sm text-bubble-muted font-display font-black">
          PuzzleKids — fun learning for everyone 🎉
        </div>
      </footer>
    </div>
  )
}
